import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  NonNullableFormBuilder,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { TranslationEntryModel } from 'src/api/services/generated/api-clients';

export interface CatalogNameTranslationFormType {
  languageCode: FormControl<string>;
  value: FormControl<string>;
}

export type CatalogNameTranslationsFormArray = FormArray<FormGroup<CatalogNameTranslationFormType>>;

export function getCatalogNameTranslationLanguageCodes(
  availableLanguageCodes: readonly string[] | null | undefined,
  nameTranslations: readonly TranslationEntryModel[] | null | undefined,
): string[] {
  if (availableLanguageCodes && availableLanguageCodes.length > 0) {
    return [...availableLanguageCodes];
  }

  return Array.from(new Set((nameTranslations ?? []).map((translation) => translation.languageCode))).sort();
}

export function setCatalogNameTranslationControls(
  formArray: CatalogNameTranslationsFormArray,
  fb: NonNullableFormBuilder,
  languageCodes: readonly string[],
  nameTranslations: readonly TranslationEntryModel[] | null | undefined,
) {
  formArray.clear();

  for (const languageCode of languageCodes) {
    const existingTranslation = nameTranslations?.find(
      (translation) => translation.languageCode.toLowerCase() === languageCode.toLowerCase(),
    );

    formArray.push(
      fb.group({
        languageCode: fb.control(languageCode),
        value: fb.control(existingTranslation?.value ?? '', [Validators.maxLength(200)]),
      }),
    );
  }

  formArray.updateValueAndValidity();
}

export function toCatalogNameTranslationModels(
  formArray: CatalogNameTranslationsFormArray,
): TranslationEntryModel[] {
  return formArray.controls.map(
    (group) =>
      new TranslationEntryModel({
        languageCode: group.controls.languageCode.value,
        value: group.controls.value.value,
      }),
  );
}

export function atLeastOneCatalogNameTranslationValidator(control: AbstractControl): ValidationErrors | null {
  const formArray = control as CatalogNameTranslationsFormArray;

  return formArray.controls.some((group) => group.controls.value.value.trim().length > 0)
    ? null
    : { atLeastOneCatalogNameTranslation: true };
}
